import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Edit.module.css'
import Pen from "../../../../assets/Icon/Pen"; 
import Form from '../../../../assets/Style/Form.module.css'
import { useTranslation } from 'react-i18next';

const Edit = ({ websiteService, defaultWebsite }) => {
    const {t} = useTranslation();

    const websiteResetData = {
        id: 0,
        name: "", 
        company_win: 0,
        level1: 0,
        level2: 0,
        level3: 0,
        level4: 0,
        level5: 0
    }

    const initEditWebsite = (website) => {
        return {
            id: website.id,
            name: website.name,
            company_win: website.company_win,
            level1: website.level1,
            level2: website.level2,
            level3: website.level3,
            level4: website.level4,
            level5: website.level5
        }
    }

    const [newWebsite, setNewWebsite] = useState(websiteResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const validateWebsite = (website) => {
        const messages = {};
    
        if (website.name.length < 2) {
            messages.name = { message: 'მიუთითეთ სახელი', isValid: false };
        }
 
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;  
      };

    const reValidate = () => {
        const isValidate = validateWebsite(newWebsite)
        
    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateWebsite(newWebsite)
        }
      }, [newWebsite, isFirstValidated]);

      useEffect(() => {
        const editedCar = initEditWebsite(defaultWebsite)
        setNewWebsite(editedCar)
    }, [defaultWebsite]);

    const [isModalOpen, setIsModalOpen] = useState(false);
 
    const saveHandle = () => {
        const isValidate = validateWebsite(newWebsite);

        if (isValidate === true) {
            const websiteToSave = {
                ...newWebsite,
                level1: convertToInt(newWebsite.level1),
                level2: convertToInt(newWebsite.level2),
                level3: convertToInt(newWebsite.level3),
                level4: convertToInt(newWebsite.level4),
                level5: convertToInt(newWebsite.level5),
            };

            websiteService.update(websiteToSave);
            setIsModalOpen(false);
        } else {
            setIsFirstValidated(true);
        }
    };

    const handleWebsiteChange = async (event) => {
        let val = event.target.value;
        setNewWebsite(prevWebsite => ({
            ...prevWebsite,
            [event.target.name]: val
        })); 
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true) 
        setIsFirstValidated(false) 
    }

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }
 
  
    const handleWebsiteInt = async (event) => {
        let val = event.target.value;
        
        setNewWebsite(prevWebsite => ({
            ...prevWebsite,
            [event.target.name]: convertToInt(val)
        })); 
    };


    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; // Regular expression to match only numeric characters

        if (!regex.test(keyValue)) {
            event.preventDefault();
        }
    };
  
    return (
        <div>

            <span className={ cl.editBtn } onClick={() => openAdd()} >
                <Pen/> {t('Update')}
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={cl.iconHead} > <Pen /></span>  {t('Update')}
                    </h3>
                </div>

                <div className={cl.groupInput}> 
                    <label>{t('Name')}</label>
                    <input type="text" className={validates && validates.name ? cl.input + ' ' + cl.errorInput : cl.input}
                        placeholder={t('Name')}
                        name="name" 
                        value={newWebsite.name} 
                        onChange={handleWebsiteChange} 
                        autoComplete="off" />
                </div>

                {/* Add inputs for levels */}
                <div className={cl.groupInput}>
                    <label>{t('Level')} 1</label>
                    <input type="text" name="level1" className={cl.input}
                        value={newWebsite.level1}
                        onChange={handleWebsiteChange} />
                </div>
                <div className={cl.groupInput}>
                    <label>{t('Level')} 2</label>
                    <input type="text" name="level2" className={cl.input}
                        value={newWebsite.level2}
                        onChange={handleWebsiteChange} />
                </div>
                <div className={cl.groupInput}>
                    <label>{t('Level')} 3</label>
                    <input type="text" name="level3" className={cl.input}
                        value={newWebsite.level3}
                        onChange={handleWebsiteChange} />
                </div>
                <div className={cl.groupInput}>
                    <label>{t('Level')} 4</label>
                    <input type="text" name="level4" className={cl.input}
                        value={newWebsite.level4}
                        onChange={handleWebsiteChange} />
                </div>
                <div className={cl.groupInput}>
                    <label>{t('Level')} 5</label>
                    <input type="text" name="level5" className={cl.input}
                        value={newWebsite.level5}
                        onChange={handleWebsiteChange} />
                </div>

                <div className={ cl.groupPrice }>
                    <label className={ cl.leftLabel }>{t('CompanyProfit')}</label>
                    <div className={ cl.rightInput }>
                        <div className={ Form.priceInput }> 
                            <div className={ Form.priceCurrency }>USD</div>
                            <input type="textS" onKeyPress={handleKeyPress} name="company_win" className={ Form.input } 
                            value={newWebsite.company_win} 
                            onChange={handleWebsiteInt} 
                            min="0"/>
                            <div className={ Form.hundred } >.00</div>
                        </div>
                    </div>
                </div>
                  
                <span onClick={saveHandle} className={cl.btnPrimary}>{t('Save')}</span>

            </Modal>
        </div>
    );
};

export default Edit;